/**
 * @author lifei & gll
 * 功能：
 */
import { Service } from '@/tools'

export class MenuService<T extends TUser.Menu> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.Menu}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：系统配置/系统菜单管理/查询菜单树
   * /api/user/menu/v1/tree
   */
  tree = <K extends T['ApiTree']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiTree', data)

  /**
   * 功能：系统配置/系统菜单管理/查询菜单树 含数据权限
   * /api/user/menu/v1/menuTreeData
   */
  menuTreeData = <K extends T['ApiMenuTreeData']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiMenuTreeData', data)

  /**
   * 功能：系统配置/系统菜单管理/删除菜单
   * /api/user/menu/v1/deleteMenu
   */
  deleteMenu = <K extends T['ApiDeleteMenu']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteMenu', data)

  /**
   * 功能：系统配置/系统菜单管理/编辑目录/页面
   * /api/user/menu/v1/update
   */
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)

  /**
   * 功能：系统配置/系统菜单管理/编辑目录/页面
   * /api/user/menu/v1/add
   */
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)

  /**
   * 功能：系统配置/系统菜单管理/查询页面下按钮列表
   * /api/user/menu/v1/buttonList
   */
  buttonList = <K extends T['ApiButtonList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiButtonList', data)

  /**
   * 功能：系统配置/系统菜单管理/删除按钮
   * /api/user/menu/v1/deleteButton
   */
  deleteButton = <K extends T['ApiDeleteButton']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteButton', data)

  /**
   * 功能：系统配置/系统菜单管理/修改按钮
   * /api/user/menu/v1/updateButton
   */
  updateButton = <K extends T['ApiUpdateButton']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateButton', data)

  /**
   * 功能：系统配置/系统菜单管理/修改按钮
   * /api/user/menu/v1/addButton
   */
  addButton = <K extends T['ApiAddButton']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddButton', data)

  /**
   * 功能：系统配置/系统菜单管理/查询页面下列表权限列表
   * /api/user/menu/v1/fieldList
   */
  fieldList = <K extends T['ApiFieldList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiFieldList', data)

  /**
   * 功能：系统配置/系统菜单管理/删除列表
   * /api/user/menu/v1/deleteField
   */
  deleteField = <K extends T['ApiDeleteField']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteField', data)

  /**
   * 功能：系统配置/系统菜单管理/修改列表
   * /api/user/menu/v1/updateField
   */
  updateField = <K extends T['ApiUpdateField']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateField', data)

  /**
   * 功能：系统配置/系统菜单管理/新增列表
   * /api/user/menu/v1/addField
   */
  addField = <K extends T['ApiAddField']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddField', data)
}
